// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"2998e8c7","239":"050679e7","367":"54686f8d","450":"76bfafb4","732":"da7299e0"}[chunkId] + ".chunk.js";
};